<template>
  <div>
    <Card :dis-hover="true">
      <div class="search-panel">
        <ul class="list-group">
          <li class="list-group-item">
            <div class="item-label">平台: </div>
            <ul class="item-list">
              <li><span @click="selectitem('connector', 'lazada')" :class="{ active: filter.connector=='lazada' }" class="option-item">lazada</span></li>
              <li><span @click="selectitem('connector', 'shopee')" :class="{ active: filter.connector=='shopee' }" class="option-item">shopee</span></li>
            </ul>
          </li>
          <li class="list-group-item">
            <div class="item-label">店铺: </div>
            <ul class="item-list">
              <li @click="selectitem('store_id', item.id)" v-for="(item, index) in stores[filter.connector]" :key="index"><span :class="{ active: item.active==true }" class="option-item">{{item.name}}</span></li>

            </ul>
          </li>
          <li class="list-group-item">
            <div class="item-label">分组: </div>
            <ul class="item-list">
              <li @click="selectitem('group_id', item.id)" v-for="(item, index) in groupList" :key="index"><span :class="{ active: item.active==true }" class="option-item">{{item.name}}</span></li>

            </ul>
          </li>
          <li class="list-group-item">
            <div class="item-label">搜索: </div>
            <Input v-model="searchval" style="width: 500px" >
                    <Select v-model="searchfield" slot="prepend" style="width: 80px">
                        <Option value="buyer_name">买家昵称</Option>
                    </Select>
                    <Button @click="request" slot="append" icon="ios-search"></Button>
                </Input>
           
          </li>
        </ul>
      </div>
      <Divider style="margin: 0px;" dashed />
      <div style="padding: 10px 0px;" class="tools">
        <Button @click="groupBoxShow" size="small" type="primary">分组管理</Button>
        &nbsp;
        <Button @click="setGroupModal = true" size="small" type="primary">设置分组</Button>
        &nbsp;
        <Button @click="buyersMsgModal = true" size="small" type="primary">群发消息</Button>
      </div>
      <Table @on-sort-change="sortEvent" @on-select-all="selectEvent" @on-select="selectEvent" :loading="loading" :columns="columns" :data="data" height="400">
        <template slot-scope="{ row }" slot="group">
            <strong>{{ row.group_one ? row.group_one.name : '' }}</strong>
        </template>
        <template slot-scope="{ row }" slot="store_name">
            <strong>{{ row.store ? row.store.name : '' }}</strong>
        </template>
        <template slot-scope="{ row }" slot="action">
            <Icon style="cursor: pointer;" size="20" title="打开聊天" @click="openSession(row)" type="md-ionitron" />
          </template>
      </Table>
      <div class="page-wrap">            
        <Page :total="total"  @on-change="switchPage" @on-page-size-change="switchPagesize" show-sizer />
      </div>
    </Card>


     <Modal 
        v-model="groupModal"
        title="分组管理"
        :footer-hide="true"
        width="1200"
        >
        <GroupBox ref="groupBoxEle"></GroupBox>
    </Modal>

     <Modal 
        v-model="setGroupModal"
        title="设置分组"
        :footer-hide="true"
        width="400"
        >
         <Form :model="setGroupForm" :label-width="80">
          <FormItem label="分组名">
            <Select v-model="setGroupForm.group_id" style="width:200px">
                  <Option v-for="item in groupList" :value="item.id" :key="item.id">{{ item.name }}</Option>
              </Select>
          </FormItem>
          <FormItem>
              <Button @click="setGroup()" type="primary">确定</Button>
          </FormItem>
        </Form>
    </Modal>

    <Modal 
        v-model="buyersMsgModal"
        title="群发消息"
        :footer-hide="true"
        width="400"
        >
         <Form :model="buyersMsgForm" :label-width="80">
          <FormItem label="群发消息">
            <Input v-model="buyersMsgForm.content" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="请输入群发内容"></Input>
          </FormItem>
          <FormItem>
              <Button @click="buyersMsgSend()" type="primary">确定</Button>
          </FormItem>
        </Form>
    </Modal>
  </div>
</template>
<script>
import RequestUtils from "@/utils/RequestUtils";
import GroupBox from "./groupBox.vue";
import Vue from 'vue';
import conf from "@/views/im/conf";

export default {
  components: {
    GroupBox
  },

  data() {
    return {
      loading: false,
      groupModal: false,
      setGroupModal: false,
      buyersMsgModal: false,
      groupList: [],
      selection: [],
      sortData: {},
      total: 0,
      curPage: 1,
      pageSize: 10,
      searchfield: 'buyer_name',
      searchval: '',
      filter: {
        connector: 'lazada',
        group_id: 0,
        store_id: 0
      },
      setGroupForm: {
        group_id: ''
      },
      buyersMsgForm: {
        content: ''
      },
      columns: [
          {
              type: 'selection',
              width: 60,
              align: 'center'
          },
          {
              title: '买家名',
              key: 'buyer_name'
          },
          {
              title: '店铺',
              slot: 'store_name'
          },
          {
              title: '最后沟通时间',
              key: 'last_message_time_text',
          },
          {
              title: '最后群发时间',
              key: 'mass_send_time',
              sortable: 'custom'
          },
          {
              title: '最后购买的SKU',
              key: 'last_purchase_sku'
          },
          {
              title: '分组',
              slot: 'group'
          },
          {
              title: '交易总额',
              key: 'trade_amount'
          },
          {
              title: '交易笔数',
              key: 'trade_num',
              sortable: 'custom'
          },
          {
              title: '平均交易金额',
              key: 'avg_trade_amount'
          },
          {
              title: '操作',
              slot: 'action',
              width: 150,
              align: 'center'
          }
      ],
      data: [
        
      ]
    }
  },
  computed: {

    stores: {
      get: function() {
        return this.$store.state.storeOpt;
      }
    },
  },
  methods: {
    groupBoxShow () {
      this.groupModal = true;
      this.$refs.groupBoxEle.request();
    },
    authorize () {
      let param = new FormData();
      param.set("appcate", 'IM');

      RequestUtils.request(conf.getAuthUrl(this.filter.connector), param)
      .then(data => {      
        window.open(data.url,"Add Account", "width=1024,height=600,toolbar=no,location=no,directories=no,status=no,menubar=yes,scrollbars=yes");
      })
    },
    openSession(row) {
      this.$store.commit(this.filter.connector+"/openSession", {
        buyer_id: row.buyer_id,
        store_id: row.store_id
      });
    },
    selectitem (key, value) {
      if (key == 'store_id') {
        let store = this.stores[this.filter.connector];
        for (let i=0; i<store.length; i++) {
          if (store[i].id == value) {
            store[i].active = true;
          } else {
            store[i].active = false;            
          }
        }
        Vue.set(this.stores, this.filter.connector, store);
      } else if (key == 'group_id') {
        for (let i=0; i<this.groupList.length; i++) {
          if (this.groupList[i].id == value) {          
            this.groupList[i].active = true;
          } else {
            this.groupList[i].active = false;            
          }
        }
      }
      this.filter[key] = value;
      this.request();
    },
    switchPage (index) {
      this.curPage = index;
      this.request();
    },
    switchPagesize (size) {
      this.pageSize = size;
      this.request();
    },
    buildparams () {
      let param = new FormData();
      param.set("page", this.curPage );
      param.set("limit", this.pageSize );
      param.set("connector", this.filter.connector );
      param.set("store_id", this.filter.store_id );
      param.set("group_id", this.filter.group_id );
      if (this.searchval) {
        param.set(this.searchfield, this.searchval);
      }
      if (this.sortData.key) {
        param.set("sort", this.sortData.key );
        param.set("order", this.sortData.order );
      }
      return param;
    },
    request () {
      let self = this;
      self.loading = true;
      RequestUtils.request(conf.getBuyerList(), self.buildparams())
      .then(data => {
        self.total = data.total;
        self.data = data.data;
        self.loading = false;
      })
    },
    selectEvent(selection) {
      this.selection = selection;
      console.log(this.selection);
    },
    sortEvent(data) {
      this.sortData = data;
      this.request();
    },
    setGroup() {
      let buyer_ids = new Array();
      for (let i=0; i<this.selection.length; i++) {
        buyer_ids.push(this.selection[i].id);
      }
      if (buyer_ids.length == 0) {
        return this.$Message.error('请先选择需要设置的买家');
      }
      let param = new FormData();
      param.set("group_id", this.setGroupForm.group_id );
      param.set("buyer_ids", buyer_ids.join(','));
      param.set("connector", this.filter.connector);

      RequestUtils.request(conf.setGroup(), param)
      .then(() => {
        this.setGroupModal = false;
        this.selection = [];
        this.request();
      })
    },
    getGroupList() {
      let param = new FormData();
      param.set("type", 'all' );

      RequestUtils.request(conf.getSessionGroup(), param)
      .then(data => {
        this.groupList = data;
        this.groupList.unshift({
          'id': 0,
          'name': '全部',
          'active': true
        })
      })
    },
    buyersMsgSend() {
      let buyer_ids = new Array();
      for (let i=0; i<this.selection.length; i++) {
        buyer_ids.push(this.selection[i].id);
      }
      if (buyer_ids.length == 0) {
        return this.$Message.error('请先选择需要设置的买家');
      }

      let param = new FormData();
      param.set("connector", this.filter.connector);
      param.set("buyer_ids", buyer_ids.join(','));
      param.set("content", this.buyersMsgForm.content);

      this.buyersMsgModal = false;
      RequestUtils.request(conf.buyersMsgSend(), param)
      .then(() => {
        this.selection = [];
        this.request();
      })

    }
    
  },
  created() {
    let self = this;
    this.request();
    this.getGroupList();

    window.addEventListener('message', function(e) {
        var data = e.data;
        console.log(data);
        if (data.event == 'refresh') {                
          self.request();
        } else if (data.event == 'error') {
            self.$Message.error(data.message);
        } else if (data.event == 'success') {
            self.request();
            self.$Message.success(data.message);
        }
    })  
  }
};
</script>
<style lang="scss" scoped>
@import "@/static/styles/theme";

.ivu-tabs-content {
  height: 100%;
}
.page-wrap {
  padding-top: 3rem;
}

.search-panel {
  padding: 2rem;

  .list-group-item {
    display: flex;
    align-items: center;
    border: 0px;
    position: relative;
    padding: 10px 0px;

    .item-label {
      width: 90px;
    }

    .item-list {
      padding: 0px;
      max-height: 120px;
      overflow: scroll;
      overflow-x: hidden;

      li {
        display: inline-block;
        margin: 0px 3px;
        cursor: pointer;
        color: #428bca;

        .option-item {
          padding: 2px 5px;
          border-radius: 3px;
        }
        .option-item.active {
          background: #428bca;
          color: #fff;
        }
      }
    }
  }
}

.panel-box {
  width: 26rem;
  background-color: $color-light-gray;
  height: 100%;
  display: flex;
  flex-direction: row;

  .chat-box {
    flex: 1;
    display: flex;
    flex-direction: column;
    position: relative;

    .layout-main {
      height: 100%;
      overflow-y: scroll;
      padding: 1rem;
      
    }
  }

  
}
</style>
